import { JsonResp, unwrapJsonResp } from "api/JsonResp";
import axios from "axios";
import { AccountType } from "shared/types/accounts";

export interface LinkedInProfile {
  id: number | string;
  localizedName: string;
  organization: string;
}

export interface LinkedInPersonalProfile extends LinkedInProfile {
  id: number | string;
  localizedName: string;
  organization: string;
  linkedinVanityName: string;
}

export interface LinkedInCompanyProfile extends LinkedInProfile {}

export function isLinkedInCompanyProfile(
  profile: LinkedInProfile
): profile is LinkedInCompanyProfile {
  return profile.organization.includes("organization");
}

export function isLinkedInPersonalProfile(
  profile: LinkedInProfile
): profile is LinkedInPersonalProfile {
  return profile.organization.includes("person");
}

export async function getLinkedInRedirect(
  reconnect: boolean = false
): Promise<string> {
  if (reconnect) {
    return `/linkedin/request_token?withPersonal=true`;
  } else {
    return `/linkedin/request_token?openAddLinkedin=true&withPersonal=true`;
  }
}

export async function getAvailableLinkedInProfiles({
  throwOnEmpty,
}: {
  throwOnEmpty: boolean;
}): Promise<LinkedInProfile[]> {
  const response = await axios.request<JsonResp<LinkedInProfile[]>>({
    method: "get",
    url: "/linkedin/getAvailablePages?all=true",
  });

  const profiles = unwrapJsonResp(response.data);
  if (throwOnEmpty && profiles.length === 0) {
    throw Error("[throwOnEmpty] no li profiles were returned");
  } else {
    return profiles;
  }
}

export async function addLinkedInProfile(
  profile: LinkedInProfile
): Promise<AccountType> {
  const response = await axios.request<JsonResp<AccountType>>({
    method: "post",
    url: "/linkedin/add",
    data: { organization: profile.organization },
  });

  return unwrapJsonResp(response.data);
}
